import React from 'react'
import CountDownTimer, {
  CountDownTimerSettings,
} from 'Event/Dashboard/components/CountDownTimer'
import EditableCountDownTimer, {
  CountDownTimerContainer,
} from 'Event/Dashboard/components/CountDownTimer/EditableCountDownTimer'
import {useEditMode} from 'Event/EditModeProvider'
import {now, date} from 'lib/date-time'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'

type CountDownTimerProps = {
  id: string
  countDownTimer: CountDownTimerSettings
  index: number
}

export default React.memo((props: CountDownTimerProps) => {
  const isEditMode = useEditMode()
  const {countDownTimers, localization} = useSimpleBlogTemplate()

  const timer = <CountDownTimer {...props.countDownTimer} id={props.id} />

  if (!isEditMode) {
    return <LiveTimer {...props}>{timer}</LiveTimer>
  }

  return (
    <EditableCountDownTimer
      id={props.id}
      countDownTimer={props.countDownTimer}
      index={props.index}
      keyPath={`countDownTimers.${props.id}`}
      countDownTimers={countDownTimers}
      localization={localization}
    >
      {timer}
    </EditableCountDownTimer>
  )
})

function LiveTimer(
  props: CountDownTimerProps & {children: React.ReactElement},
) {
  const current = now()
  const isAfter = date(props.countDownTimer.end).isAfter(current)

  if (!isAfter) {
    return null
  }

  return <CountDownTimerContainer>{props.children}</CountDownTimerContainer>
}
